import { InventaireView } from "@features/stock/components/InventaireView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/inventaires/$id/view")({
  loader: requirePermission(PERMISSIONS.STOCK.INVENTAIRES.VIEW),
  component: InventaireViewWrapper,
});

function InventaireViewWrapper() {
  const { id } = Route.useParams();
  return <InventaireView id={Number(id)} />;
}
